import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Box,
  Card,
  CircularProgress,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDataUploadContext } from "../../../context/DataUploadContext";
import Grid from "@mui/material/Grid";
import useStyles from "./DataUpload.styles";
import CommonDialog from "../../common/CommonDialog/CommonDialog";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const DataUpload = () => {
  const { classes } = useStyles();

  const {
    rows,
    attachFiles,
    removeFiles,
    uploadFiles,
    uploadAndReplaceFiles,
    dialogState,
    closeDialog,
  } = useDataUploadContext();

  const onFileChange = (index, e) => {
    try {
      const files = Array.from(e.target.files || []);
      if (!files?.length) return;
      attachFiles(index, files);
      e.target.value = ""; // Reattaching same file can be done
    } catch (err) {
      alert(err.message);
      e.target.value = "";
    }
  };

  return (
    <div className={classes.page}>
      <Card
        style={{
          padding: "6px",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            {!rows || !rows.length ? (
              <Item>
                <Typography
                  variant="p"
                  component="p"
                  sx={{
                    color: "#adadad",
                    minHeight: "250px",
                  }}
                >
                  Sorry, You dont have access / write permission to Upload
                  files!
                </Typography>
              </Item>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Number</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Attach File</TableCell>
                    <TableCell>Upload</TableCell>
                    <TableCell>Remove</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows?.map((row, index) => (
                    <TableRow
                      key={row.type}
                      sx={{
                        opacity: row.uploading ? 0.6 : 1,
                        pointerEvents: row.uploading ? "none" : "auto",
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.title}</TableCell>

                      <TableCell>
                        <input
                          type="file"
                          multiple={!!row.isMultiFileSupport}
                          accept={row.accept}
                          hidden
                          id={`file-input-${row.type}`}
                          disabled={row.uploading}
                          onChange={(e) => onFileChange(index, e)}
                        />
                        <label htmlFor={`file-input-${row.type}`}>
                          <IconButton component="span">
                            <AttachFileIcon />
                          </IconButton>
                          {row.files && row.files.length > 0
                            ? row.files?.map((file) => file.name).join(", ")
                            : row.accept
                              ? `(Accepts: ${row.accept})`
                              : ""}
                        </label>
                      </TableCell>

                      <TableCell sx={{ position: "relative" }}>
                        {row.canUploadAndUpdate && (
                          <Button
                            variant="contained"
                            onClick={() => uploadFiles(index)}
                            disabled={
                              !row.files ||
                              row.files?.length === 0 ||
                              row.uploading
                            }
                          >
                            Upload & Update
                          </Button>
                        )}
                        {row.canUploadAndReplace && (
                          <Button
                            variant="contained"
                            sx={{
                              bgcolor: "red",
                              left: row.canUploadAndUpdate && "20px",
                            }}
                            onClick={() => uploadAndReplaceFiles(index)}
                            disabled={
                              !row.files ||
                              row.files?.length === 0 ||
                              row.uploading
                            }
                          >
                            Upload & Replace
                          </Button>
                        )}
                        {/* Row-level overlay */}
                        {row.uploading && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              bgcolor: "rgba(0,0,0,0.4)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 2,
                            }}
                          >
                            <CircularProgress
                              size={32}
                              sx={{ color: "white" }}
                            />
                          </Box>
                        )}
                      </TableCell>

                      <TableCell>
                        {row.files && (
                          <IconButton
                            onClick={() => removeFiles(index)}
                            disabled={row.uploading}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Grid>
        </Grid>
      </Card>

      <CommonDialog
        open={dialogState.open}
        title={dialogState.title}
        message={dialogState.message}
        onClose={closeDialog}
        onOk={closeDialog}
        okText="OK"
        showCancel={false}
        successFiles={dialogState.successFiles}
        ignoredFiles={dialogState.ignoredFiles}
        acceptedPrefixes={dialogState.acceptedPrefixes}
      />
    </div>
  );
};

export default DataUpload;
